import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(true);
  const [isFeaturesExpanded, setIsFeaturesExpanded] = useState(true);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, 1, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  const renderStars = (rating) => {
    const stars = [];
    const rate = parseFloat(rating);
    for (let i = 1; i <= 5; i++) {
      if (i <= rate) {
        stars.push(<span key={i} className="star filled">★</span>);
      } else {
        stars.push(<span key={i} className="star empty">☆</span>);
      }
    }
    return stars;
  };

  return (
    <div className="product-detail">
      <div className="product-detail__container">
        <nav className="breadcrumb">
          <Link to="/" onClick={toTop}>Home</Link>
          <span className="separator">/</span>
          <Link to="/shop" onClick={toTop}>Shop</Link>
          <span className="separator">/</span>
          <span className="current">{product.name}</span>
        </nav>

        <div className="product-detail__content">
          <div className="product-detail__images">
            <div className="main-image">
              <img src={product.images[selectedImage]} alt={product.name} />
            </div>
            {product.images.length > 1 && (
              <div className="thumbnail-list">
                {product.images.map((img, idx) => (
                  <button
                    key={idx}
                    className={`thumbnail ${selectedImage === idx ? 'active' : ''}`}
                    onClick={() => setImage(idx)}
                  >
                    <img src={img} alt={`${product.name} ${idx + 1}`} />
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="product-detail__info">
            <div className="product-brand">{product.brand}</div>
            <h1 className="product-name">{product.name}</h1>
            
            <div className="product-rating-section">
              {product.reviews && product.reviews !== "0" && (
                <div className="product-rating">
                  {renderStars(product.rating)}
                  <span className="reviews-count">({product.reviews} Reviews)</span>
                </div>
              )}
            </div>

            <div className="product-price">
              {product.originalPrice && product.originalPrice !== product.price && (
                <span className="original-price">${product.originalPrice} USD</span>
              )}
              <span className="current-price">${product.price} USD</span>
            </div>

            <div className="product-item-number">
              <span>Item #: {product.itemNumber}</span>
            </div>

            

            <div className="product-options">
              {product.size.length > 1 && (
                <div className="option-group">
                  <label>Size:</label>
                  <div className="options">
                    {product.size.map((size, idx) => (
                      <button
                        key={idx}
                        className={`option-button ${selectedSize === size ? 'selected' : ''}`}
                        onClick={() => setSelectedSize(size)}
                      >
                        {size}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {product.colors.length > 1 && (
                <div className="option-group">
                  <label>Color:</label>
                  <div className="options">
                    {product.colors.map((color, idx) => (
                      <button
                        key={idx}
                        className={`option-button ${selectedColor === color ? 'selected' : ''}`}
                        onClick={() => setSelectedColor(color)}
                      >
                        {color}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <button className="add-to-cart-btn" onClick={handleAddToCart}>
              <span className="btn-icon">🛒</span>
              Add to Cart
            </button>

            <div className="product-section">
              <button 
                className="section-header"
                onClick={() => setIsDescriptionExpanded(!isDescriptionExpanded)}
              >
                <span className="section-title">Description</span>
                <span className={`section-toggle ${isDescriptionExpanded ? 'expanded' : ''}`}>
                  {isDescriptionExpanded ? '−' : '+'}
                </span>
              </button>
              {isDescriptionExpanded && (
                <div className="product-description">
                  {product.description.map((paragraph, idx) => (
                    <p key={idx}>{paragraph}</p>
                  ))}
                </div>
              )}
            </div>

            <div className="product-section">
              <button 
                className="section-header"
                onClick={() => setIsFeaturesExpanded(!isFeaturesExpanded)}
              >
                <span className="section-title">Features</span>
                <span className={`section-toggle ${isFeaturesExpanded ? 'expanded' : ''}`}>
                  {isFeaturesExpanded ? '−' : '+'}
                </span>
              </button>
              {isFeaturesExpanded && (
                <div className="product-features">
                  <ul>
                    {product.Features.map((feature, idx) => (
                      <li key={idx}>{feature}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
